import { ShoppingList } from "@biz/models/ShoppingList";
import { IVariantDataShop } from "@biz/userProjects/new/IVariant";

export class VariantDataShop {
  static create(): IVariantDataShop {
    return {
      type: "shop",
      shoppingList: ShoppingList.createEmpty(),
    }
  }
}